/* eslint-disable import/no-named-as-default */
import React, { useEffect, useState, useContext } from 'react';

import ResponsiveHeader from '../responsive-header/ResponsiveHeader';

import { SkipLinks } from '../link-list/LinkList';
import { skipLinks } from '../links';
import authenticateUser from '../../../client/authenticate-user';
import useShowNotification from './useShowNotification';
import NotificationBanner from '../notification-banner/NotificationBanner';
import Navigation from '../navigation/Navigation';
import Chat from '../chat/Chat';
import styles from './header-wrapper.scss';
import { UserContext } from '../../scaffold/UserContext';
import getUserProfile from '../../../client/getUserProfile';
import EnvVarsFeaturesContext from '../../scaffold/EnvVarsFeaturesContext';

const Header = ({ features }) => {
  const { bottomNotification } = useContext(EnvVarsFeaturesContext);

  const [showBottomNotification, setBottomNotification] = useShowNotification(
    bottomNotification
  );

  const [mobileNavShown, setMobileNavShown] = useState(false);

  const { updateUserState } = useContext(UserContext);
  const [componentMounted, updateComponentMounted] = useState(false);

  useEffect(() => {
    if (features.authenticationEnabled && !componentMounted) {
      authenticateUser(updateUserState);
    } else if (!features.authenticationEnabled && !componentMounted) {
      const userProfile = getUserProfile();
      updateUserState(userProfile);
    }
    updateComponentMounted(true);
  }, [componentMounted]);

  return (
    <header className={styles.siteWide}>
      <Chat />
      <div className={styles.headerContainer}>
        <SkipLinks links={skipLinks} />
        <ResponsiveHeader updateMobileNavState={setMobileNavShown} />
      </div>
      <Navigation mobileNavShown={mobileNavShown} />
      {showBottomNotification && (
        <NotificationBanner
          closeHandler={setBottomNotification}
          {...bottomNotification}
        />
      )}
    </header>
  );
};

export default Header;
